import { render, staticRenderFns } from "./ImproveCv.vue?vue&type=template&id=520c05c5&"
import script from "./ImproveCv.vue?vue&type=script&lang=js&"
export * from "./ImproveCv.vue?vue&type=script&lang=js&"
import style0 from "./ImproveCv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports